import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const RecommendedLabel: React.FC<ISvgAtomProps> = ({ width = 100, height = 12 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="#10b9811e" />
      <text x={10} y={height / 2} textAnchor="start" dominantBaseline="middle" fill="#7a7a7a" fontSize={8}>
        Recommended
      </text>
    </svg>
  );
};

export default RecommendedLabel;
